export default "__VITE_ASSET__BJQe417H__"